import { Provider } from '@cloud-native/workflows-engine'
import { WorkflowPayload } from 'features/workflows/types'
import { TENANT_REGION, REGIONS } from 'features/workflows/constants'
import { getStore } from '../../../../app/state/storeRegistry'

export const selectVariables = (workflow: WorkflowPayload) => {
  if (!workflow || !workflow?.config?.variables) {
    return []
  }

  return workflow.config.variables
}

export const selectUpdatedAt = (workflow?: WorkflowPayload) => workflow?.updatedAt || ''

export const selectTempRegion = (workflow?: WorkflowPayload) => {
  if (workflow?.config.connectionProvider === Provider.BigQuery) {
    /* ==== START TEMPORARY BLOCK === */
    // eslint-disable-next-line react-hooks/rules-of-hooks
    // const tenantId = useAppSelector((state) => state.users.me?.user_metadata.tenant_id) || ''
    const tenantId = getStore().getState().users.me?.user_metadata.tenant_id || ''
    const defaultRegion = TENANT_REGION[tenantId] || REGIONS.US
    const tempLocation = workflow?.tempLocation
    const region = tempLocation?.region || defaultRegion
    /* ==== END TEMPORARY BLOCK === */
    return region
  }
}
